/* Hardtuned / Zepto cart compatibility.
 * Restored from theme 186898055490 (Zepto Changes - Copy of Old 2026 Theme).
 * Zepto app embed remains responsible for configuration, previews and cart data.
 * Reinitialise its common script after debounced cart updates, as in that theme.
 */
(() => {
  let cartUpdateTimer;
  // Keep personaliser clicks out of delegated cart-app click handlers.
  // Zepto's own button listeners still run; the theme submit guard handles submit.
  const isolatedButtons = new WeakSet();
  function isolatePersonaliserButtons() {
    document.querySelectorAll("product-form form").forEach(form => {
      if (!form.querySelector(".product-personalizer")) return;
      form.querySelectorAll("button[name=add]").forEach(button => {
        if (isolatedButtons.has(button)) return;
        isolatedButtons.add(button);
        button.addEventListener("click", event => event.stopPropagation());
      });
    });
  }
  function syncPersonaliserUI() {
    isolatePersonaliserButtons();
    document.querySelectorAll('#monster-cart-wrapper .mu-item-property[data-key="Preview"]').forEach(property => {
      const url = property.dataset.value;
      if (!url?.startsWith("https://") || property.querySelector("a")) return;
      const link = document.createElement("a");
      link.href = url;
      link.textContent = "View design";
      link.target = "_blank";
      link.rel = "noopener";
      property.replaceChildren(document.createTextNode("Preview: "), link);
    });
  }
  syncPersonaliserUI();
  window.addEventListener("pplrAppInitiated", syncPersonaliserUI);
  new MutationObserver(syncPersonaliserUI).observe(document.body, {childList: true, subtree: true});

  // Block invalid personalised clicks before cart apps can add the plain base item.
  document.addEventListener("click", event => {
    const button = event.target.closest?.("product-form button[name=add]");
    const form = button?.closest("form");
    if (!form?.querySelector(".product-personalizer") || form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.reportValidity();
  }, true);
  // Use Zepto's completion event, not another add-to-cart request.
  window.addEventListener("pplrAddToCartCompleted", async () => {
    if (typeof window.monster_setCartItems !== "function") return;
    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(root + "cart.js", {cache: "no-store", headers: {Accept: "application/json"}});
      if (!response.ok) throw new Error("Unable to refresh the personalised cart");
      const cart = await response.json();
      await window.monster_setCartItems(cart.items);
      if (typeof window.updateCartCounters === "function") window.updateCartCounters();
      const drawer = document.getElementById("monster-cart-wrapper");
      if (drawer?.classList.contains("mu_closed")) document.getElementById("cart-counter")?.click();
    } catch (error) {
      // The item was already added. Never retry an add after a display failure.
      console.error("Zepto item added; cart refresh failed", error);
    }
  });
  document.addEventListener("cart:updated", () => {
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(() => {
      const scriptId = "pplr-common-script";
      document.getElementById(scriptId)?.remove();
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://cdn-zeptoapps.com/product-personalizer/pplr_common.js?v=" + new Date().toISOString().slice(0, 10);
      script.async = true;
      document.head.appendChild(script);
    }, 500);
  });
})();
